import {
  nativeDeliveryCampaignResourceType,
  toNativeDeliveryVariableKey,
} from "@hightouch/lib/customer-data/decision-engine/destination-definitions/native-delivery-resource-type";
import type { DecisionEngineDestinationUI } from "./definition";

export const nativeDeliveryUI: DecisionEngineDestinationUI = {
  campaignSetup: "resource",
  resourceName: "campaign",
  channelDescription: "Native delivery",
  getReferenceString: (reference) => {
    const name = reference.replace(
      /^hightouch\.recommendation\.variables\./,
      "",
    );
    return `{{ ${toNativeDeliveryVariableKey(name)} }}`;
  },
  getResourceUrl: (resource) =>
    `/native-delivery/campaigns/${resource.id}/overview`,
  isInactive: (resource) => resource.status !== "active",
  isPreviewSupported: true,
  getEmailPreviewMethod: "preview",
  isTestSendSupported: false,
  // Add message and the campaign link resolve through the same type: any
  // number of agent messages deliver through one campaign.
  getTemplateResourceType: (channel) =>
    nativeDeliveryCampaignResourceType(channel.type),
  getResourceType: (channel) =>
    nativeDeliveryCampaignResourceType(channel.type),
  showIdentifierField: false,
};
